export default "__VITE_ASSET__sx$XRO2o__"